import React from 'react';
import Layout from '@/components/layout/Layout';
import CashOutflowReport from '@/components/finance/CashOutflowReport';

const CashOutflowReportPage: React.FC = () => {
  return (
    <Layout>
      <div className="w-full max-w-full py-8 space-y-6">
        <div>
          <h1 className="text-3xl font-bold">Cash Outflow Analysis</h1>
          <p className="text-muted-foreground mt-1">
            Monitor payment requests, expenses, and cash flow performance
          </p>
        </div>
        
        <CashOutflowReport />
      </div>
    </Layout>
  );
};

export default CashOutflowReportPage;
